import { render, staticRenderFns } from "./ViewReportPto.vue?vue&type=template&id=44fd2472&"
import script from "./ViewReportPto.vue?vue&type=script&lang=js&"
export * from "./ViewReportPto.vue?vue&type=script&lang=js&"
import style0 from "./ViewReportPto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports